// The one control that adds a row to a form's list (DD-056): a secondary small button with the plus icon. Split by client,
// Split by person, Who does what and a contract's lines all add a row with it.
import type { ReactNode } from "react";
import { PlusIcon } from "@/components/icons";
import { Button } from "@/components/ui/Button";

interface Props {
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
}

export function AddRowButton({ onClick, disabled, children }: Props) {
  return (
    <Button variant="secondary" size="sm" onClick={onClick} disabled={disabled}>
      <PlusIcon className="w-4 h-4" />
      {children}
    </Button>
  );
}
